// export const BASE_URL = "http://localhost:8000/api";
export const BASE_URL = "https://api.vallettagroup.in";
